const getPreferenceCenterPhoneNumberInput = require("./getPreferenceCenterPhoneNumberInput");

/**
 * @param preferenceCenter {HTMLElement}
 * @param phoneNumber {string}
 * @return {void}
 */
module.exports = function setPreferenceCenterPhoneNumber(preferenceCenter, phoneNumber) {
    const phoneNumberInput = getPreferenceCenterPhoneNumberInput(preferenceCenter);
    phoneNumberInput.value = phoneNumber;
}